export enum HelpTrackingEvent {
  CommunityWidget = `[Help Widget] Community Widget`,
  ContactSales = `[Help Widget] Contact Sales`,
  Docs = `[Help Widget] Documentation`,
  ExternalLink = `[Help Widget] External Link`,
  Intro = `[Help Widget] Learn Mixpanel Basics`,
  SetupGuide = `[Help Widget] Setup Guide`,
  GettingStarted = `[Help Widget] Getting Started`,
  WhatsNew = `[Help Widget] What's New`,
  LiveChat = `[Help Widget] Live Chat Started`,
  Community = `[Help Widget] Visit Community`,
  HireAnExpert = `[Help Widget] Hire an Expert`,
  Support = `[Help Widget] Support`,
  OnboardingGuide = `[Help Widget] Onboarding Guide`,
  DocsLink = `[Help Widget] Clicked Docs`,
}
